import { render, staticRenderFns } from "./binvitation.vue?vue&type=template&id=56de879e&scoped=true&"
import script from "./binvitation.vue?vue&type=script&lang=js&"
export * from "./binvitation.vue?vue&type=script&lang=js&"
import style0 from "./binvitation.vue?vue&type=style&index=0&id=56de879e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de879e",
  null
  
)

export default component.exports